module.exports = __webpack_public_path__ + "img/11087930_L.8e2018f4.png";